import z from "zod/v4";

/**
 * Splits a string on the given delimiter. An empty string decodes to an
 * empty array — `"".split(d)` would otherwise yield `[""]`, which is rarely
 * what callers want when piping into a per-element codec.
 */
export const delimited = (delimiter: string) =>
  z.codec(z.string(), z.array(z.string()), {
    decode: (s) => (s ? s.split(delimiter) : []),
    encode: (arr) => arr.join(delimiter),
  });
